
interface Number {

  roundTo(dp?: number): number;
  toFixedM(pd?: number): number;

  unit2kilo(): number;
  kilo2unit(): number;
  unit2mega(): number;
  kilo2mega(): number;
}

Number.prototype.roundTo = function (this: number, dp?: number): number {
  if (dp === undefined) dp = 0;
  return parseFloat(this.toFixed(dp));
}

Number.prototype.toFixedM = function (this: number, dp?: number ): number {

  if (this % 1 === 0) return this;
  if (this < 0.01) return parseFloat(this.toFixed(((dp === undefined) ? 6 : dp))); 
  if (this < 0.1) return parseFloat(this.toFixed(((dp === undefined) ? 5 : dp))); 
  if (this < 1) return parseFloat(this.toFixed(((dp === undefined) ? 4 : dp))); 
  if (this < 10) return parseFloat(this.toFixed(((dp === undefined) ? 3 : dp))); 
  if (this < 100) return parseFloat(this.toFixed(((dp === undefined) ? 2 : dp))); 
  if (this < 1000) return parseFloat(this.toFixed((dp === undefined) ? 1 : dp)); 
  return parseFloat(this.toFixed((dp === undefined) ? 0 : dp)); 

}

Number.prototype.unit2kilo = function (this: number): number { return this / 1e3; }

Number.prototype.kilo2unit = function (this: number): number { return this * 1e3; }

Number.prototype.unit2mega = function (this: number): number { return this / 1e6; };

Number.prototype.kilo2mega = function (this: number): number { return this * 1e6; };


